import { SelectField } from '@sequencehq/core-components'
import { useExternalLedgerForm } from 'InvoiceEditor/components/LineItems/drawer/LineItemEditor/components/ExternalLedgerForm/useExternalLedgerForm'

export const ExternalLedgerForm = () => {
  const { fieldsConfig } = useExternalLedgerForm()

  if (fieldsConfig.integrations.length === 0) {
    return null
  }

  return (
    <>
      {fieldsConfig.integrations.map(integrationField => (
        <SelectField
          key={integrationField.id}
          label={integrationField.label}
          data-testid={`integration-${integrationField.id}`}
          value={integrationField.value}
          onChange={integrationField.onChange}
          options={integrationField.options}
          validationErrors={integrationField.validationErrors}
          isDisabled={integrationField.disabled}
          placeholder={`Choose ${integrationField.label}`}
        />
      ))}
    </>
  )
}
